import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private $loadingVisibleChange: Subject<boolean> = new Subject<boolean>();

  getState(): Observable<any> {
    return this.$loadingVisibleChange.asObservable();
  }

  setFalse() {
    this.$loadingVisibleChange.next(false);
  }

  setTrue() {
    this.$loadingVisibleChange.next(true);
  }
}
